import { Button } from 'components'
import { ComponentProps } from 'react'
import { Box, Flex } from 'theme-ui'
export type TabbedMenuProps = {
  options?: ComponentProps<typeof Button>[] | string[]
}

export const TabbedMenu = ({ options, ...rest }: TabbedMenuProps) => {
  return (
    <Flex
      variant="forms.button.container"
      sx={{
        justifyContent: 'center',
        mt: 24,
        padding: 1,
      }}>
      <Box
        sx={{
          backgroundColor: '#FDF0D1',
          borderRadius: '40px',
          display: 'flex',
          justifyContent: 'space-between',
          padding: 1,
        }}>
        {options && options.map((option) => option)}
      </Box>
    </Flex>
  )
}
